import UserCls from "@outschool/user";
const User = new UserCls();
export default User;
